
import { computed, defineComponent, ref } from 'vue';

export default defineComponent({
    name: 'SearchATSPanel',
    components: {},
    props: {
        handleSearch: {
            type: Function,
            required: true,
        }
    },
    setup(props) {
        const mer = ref('');
        const rge = ref('');
        const twp = ref('');
        const sec = ref('');
        const qtr = ref('');
        const lsd = ref('');
        const isSearching = ref<boolean>(false);

        const isClearable = computed(() => isSearching.value);
        // mer.value.length
        // || rge.value.length
        // || twp.value.length
        // || sec.value.length
        // || qtr.value.length
        // || lsd.value.length
        // );

        const clearForm = () => {
            mer.value = '';
            rge.value = '';
            twp.value = '';
            sec.value = '';
            qtr.value = '';
            lsd.value = '';
            isSearching.value = false;
        };

        const onEnter = () => {
            if (!mer.value || !rge.value) {
                return;
            }
            isSearching.value = true;

            let query = `W${mer.value}-${rge.value}`;

            if (twp.value) {
                query = `${query}-${twp.value}`;
                if (sec.value) {
                    query = `${query}-${sec.value}`;
                    if (qtr.value) {
                        query = `${query}-${qtr.value}`;
                        if (lsd.value) {
                            query = `${query}-${lsd.value}`;
                        }
                    }
                }
            }

            clearForm();
            props.handleSearch(query);
        };

        return {
            mer,
            rge,
            twp,
            sec,
            qtr,
            lsd,
            isClearable,
            clearForm,
            onEnter
        };
    }
});
